import React from "react";
import { Card, CardHeader, CardBody, ListGroup } from "reactstrap";
import { arrayOf, shape, string, bool } from "prop-types";
import KeyholderItem from "./KeyholderItem";

function KeyholdersCard({ keyholdersList, isBankAccountCreated }) {
  const isEveryKeyholderSentKey = keyholdersList.every(k => k.status);
  const headerText =
    isEveryKeyholderSentKey && isBankAccountCreated
      ? "Successful registered"
      : "Now Pending";

  const headerStyle = isEveryKeyholderSentKey ? { color: "green" } : {};
  return (
    <Card>
      <CardHeader style={headerStyle}>{headerText}</CardHeader>
      <CardBody>
        <div className="mb-3">Key holders:</div>
        <ListGroup>
          {keyholdersList.map(({ username, status, fullName }) => (
            <KeyholderItem key={username} status={status} name={fullName} />
          ))}
        </ListGroup>
      </CardBody>
    </Card>
  );
}

KeyholdersCard.propTypes = {
  keyholdersList: arrayOf(
    shape({
      username: string.isRequired,
      status: bool.isRequired,
      fullName: string.isRequired,
    }),
  ).isRequired,
  isBankAccountCreated: bool.isRequired,
};

KeyholdersCard.defaultProps = {
  keyholdersList: [],
  isBankAccountCreated: false,
};

export default KeyholdersCard;
